// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
exports.push([module.id, "@import url(//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick.css);"]);
exports.push([module.id, "@import url(//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick-theme.css);"]);
// Module
exports.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"ScheduleTable.vue"}]);
// Exports
module.exports = exports;
